import React from 'react';
import SearchBar from "./Search";
import ControlButton, { ControlButtonColor } from "./ControlButton";
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        gap: 16,
        alignItems: 'stretch',
        width: '96%'
    }
}));

type ControlProps = {
    query: string;
    setQuery: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onImport?: () => void;
    onAnnouncement?: () => void;
}

const Control: React.FC<ControlProps> = ({ 
    query, 
    setQuery, 
    onImport,
    onAnnouncement 
}) => {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <SearchBar
                    empty={false}
                    query={query}
                    setQuery={setQuery}
                />
                {onImport && (<ControlButton
                    icon="file-upload"
                    title="Import Members"
                        subtitle="Upload CSV File"
                        color={ControlButtonColor.BLUE}
                        onClick={onImport}
                    />
                )}
                {onAnnouncement && (<ControlButton
                    icon="bullhorn"
                    title="Send Announcement"
                    subtitle="To all active members"
                    color={ControlButtonColor.ORANGE}
                    onClick={onAnnouncement}
                />)}
            
        </div>
    );
};

export default Control;